export default {
  ROLE_SUPER_ADMIN: 'Super Admin',
  ROLE_ADMIN_PAYEUR: 'Administrateur payeur',
  ROLE_ADMIN_ENTREPRISE: 'Administrateur entreprise',
  ROLE_REFERENT: 'Référent par défaut',
  ROLE_BENEFICIAIRE: 'Bénéficiaire',
  //ROLE_PARTICULIER: 'Particulier',
  ROLE_INVITE : 'Invité',

  ROLE_TYPE_SUPER_ADMIN: 'super_admin',
  ROLE_TYPE_ADMIN: 'admin',
  ROLE_TYPE_MANAGER: 'manager',
  ROLE_TYPE_BENEFICIARY: 'beneficiary'
};